import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader, setCookie } from "../Helpers";
import {
  STR_CONTACT_US,
  STR_LOGOUT,
  STR_YOUR_PROFILE,
} from "../Strings";
import { 
  MdSupportAgent, MdTranslate, MdLogout, MdVerified, 
  MdChevronRight, MdMailOutline, MdLanguage 
} from 'react-icons/md';
import { LiaUserSolid } from "react-icons/lia";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getCurrentUserData()])
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('userId', "", -10000000);
    setCookie('userToken', "", -10000000);
    appContext.navTo({ item: '' });
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => { init(); }, []);

  // Reusable Option Item Component for consistency
  const MenuOption = ({ icon, label, onClick, color = "#475569", showArrow = true }) => (
    <div
      className="d-flex align-items-center justify-content-between py-3 px-2 mb-2 menu-item-row"
      style={{ cursor: "pointer", transition: "all 0.2s" }}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        <div 
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: "40px", height: "40px", backgroundColor: `${color}15`, color: color }}
        >
          {icon}
        </div>
        <h6 className="m-0 ms-3 font-semi-bold" style={{ fontSize: "15px", color: "#1e293b" }}>
          {label}
        </h6>
      </div>
      {showArrow && <MdChevronRight size={22} className="text-muted" />}
    </div>
  );

  if (!ready) {
    return <div className="mSupportLoading vh-100">{getInlineLoader()}</div>;
  }

  return (
    <div
      className="mNoScrollBar"
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        backgroundColor: "#f8fafc", // Soft background color
        paddingBottom: "100px",
      }}
    >
      <style>{`
        .profile-card {
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
          border-radius: 24px;
          border: none;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
        }
        .settings-container {
          background: #ffffff;
          border-radius: 24px;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
          padding: 10px;
        }
        .menu-item-row:active {
          background-color: #f1f5f9;
          border-radius: 12px;
          transform: scale(0.98);
        }
        .avatar-glow {
          background: #ffffff;
          box-shadow: 0 0 20px rgba(var(--primaryColorRGB), 0.2);
          border: 4px solid #fff;
        }
      `}</style>

      <div className="container py-4">
        {/* Premium Profile Header */}
        <div className="card profile-card mb-4 overflow-hidden">
          <div className="card-body text-center py-5">
            <div 
              className="avatar-glow rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
              style={{ width: "100px", height: "100px" }}
            >
              <LiaUserSolid size={60} className="text-primary" />
            </div>
            
            <h4 className="fw-bold mb-1" style={{ color: "#0f172a" }}>
              {appContext.currentUserData.fullname}
            </h4>
            
            <div className="d-flex align-items-center justify-content-center gap-2">
              <span className="text-muted small fw-medium">
                {appContext.currentUserData.agentName}
              </span>
              {appContext.currentUserData.agentVerificationStatus === 'verified' && (
                <MdVerified className="text-primary" size={18} />
              )}
            </div>
          </div>
        </div>

        {/* Settings Groups */}
        <div className="settings-container">

          <MenuOption 
            icon={<MdLanguage size={22} />} 
            label={appContext.language === 'en' ? "Tumia Kiswahili" : "Use English"} 
            color="#10b981"
            onClick={() => appContext.setLanguage(appContext.language === 'en' ? 'sw' : 'en')}
          />

          <hr style={{ opacity: "0.05", margin: "10px 0" }} />

          <MenuOption 
            icon={<MdLogout size={22} />} 
            label={STR_LOGOUT[appContext.language]} 
            color="#ef4444"
            showArrow={false}
            onClick={() => {
              appContext.activateDialog({
                message: `${STR_LOGOUT[appContext.language]}?`,
                onConfirm: logOut,
              })
            }}
          />
        </div>

      </div>
    </div>
  );
}